function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 25,
    viewBox: "0 0 24 25",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M6.742 2.65a1.55 1.55 0 011.566.029l13.498 8.248a1.55 1.55 0 010 2.646L8.308 21.822a1.55 1.55 0 01-2.358-1.323V4.001a1.55 1.55 0 01.792-1.352zm.808 1.44v16.32l13.352-8.16z",
    fill: props.fill,
    fillRule: "evenodd"
  }));
}

export default SvgPlay;